import React, {Component} from 'react';
import auth from '../../../../../../services/auth';
import CenteredLoadingAnimation from '../../../../../../components/CenteredLoadingAnimation';

class Callback extends Component {

  componentWillMount() {
    auth.handleAuthentication();
  }

  render() {
    return <CenteredLoadingAnimation />;
  }
}

export default Callback;



// WEBPACK FOOTER //
// ./src/layout/App/components/AuthContainer/components/Callback/Callback.js